export default [
  {
    name: 'priceVendorManagement',
    label: 'labels.vendorPriceModule.permission.management',
    permissionKey: 'price_vendor_management',
    children: [
      {
        name: 'priceVendorAdd',
        label: 'labels.vendorPriceModule.permission.add',
        permissionKey: 'price_vendor_add'
      },
      {
        name: 'priceVendorEdit',
        label: 'labels.vendorPriceModule.permission.edit',
        permissionKey: 'price_vendor_edit'
      },
      {
        name: 'priceVendorDelete',
        label: 'labels.vendorPriceModule.permission.delete',
        permissionKey: 'price_vendor_delete'
      },
      {
        name: 'priceVendorArchive',
        label: 'labels.vendorPriceModule.permission.archive',
        permissionKey: 'price_vendor_archive'
      }
    ]
  }
]
